var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddWallet(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "add icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wallet",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1286.000000, -330.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    fill: "#E9EBEC",
    x: 0,
    y: 0,
    width: 1440,
    height: 1024
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rect",
    fill: "#F8F9FA",
    x: 150,
    y: 74,
    width: 1280,
    height: 940,
    rx: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "add-member",
    transform: "translate(1280.000000, 324.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18,0 L112,0 C121.941125,-1.82615513e-15 130,8.0588745 130,18 C130,27.9411255 121.941125,36 112,36 L18,36 C8.0588745,36 1.21743675e-15,27.9411255 0,18 C-1.21743675e-15,8.0588745 8.0588745,1.82615513e-15 18,0 Z",
    id: "button/unhighlight",
    fill: "#424649"
  }), /*#__PURE__*/React.createElement("g", {
    id: "rect-2",
    transform: "translate(6.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Components/5.-Avatar",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 24,
    height: 24,
    rx: 12
  }), /*#__PURE__*/React.createElement("g", {
    id: "jiajianzujianjiahao",
    transform: "translate(4.998828, 5.000000)",
    fill: "#BFCBCB"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.83331767,5.83331767 L1.16959615,5.83331767 C0.859773999,5.83285624 0.562427444,5.95554438 0.343061942,6.1743801 C0.12369644,6.39314745 0.000341797292,6.69015221 0,7.00004272 C0,7.64865436 0.52383853,8.16668233 1.16959615,8.16668233 L5.83331767,8.16668233 L5.83331767,12.8304209 C5.83331767,13.4767596 6.35543012,14 7.00004272,14 C7.64865436,14 8.16668233,13.4761615 8.16668233,12.8304209 L8.16668233,8.16668233 L12.8304209,8.16668233 C13.1402431,8.16716085 13.4375726,8.04445562 13.6569381,7.82568826 C13.8763036,7.60685255 13.9997437,7.30984779 14,7.00004272 C14,6.35136273 13.4761615,5.83331767 12.8304209,5.83331767 L8.16668233,5.83331767 L8.16668233,1.16957906 C8.16716085,0.859773999 8.04445562,0.562427444 7.82568826,0.343061942 C7.60685255,0.12369644 7.30984779,0.000341797292 7.00004272,0 C6.35136273,0 5.83331767,0.52383853 5.83331767,1.16957906 L5.83331767,5.83331767 Z",
    id: "Fill-1"
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddWallet);
export default __webpack_public_path__ + "static/media/addWallet.3f24ae68d7efbb5ca58c0cf36b8f251b.svg";
export { ForwardRef as ReactComponent };